import { render, staticRenderFns } from "./HornimanMuseum.vue?vue&type=template&id=01951ada&"
import script from "./HornimanMuseum.vue?vue&type=script&lang=js&"
export * from "./HornimanMuseum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports